import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-top: 48px;
  margin-bottom: 24px;
`

const OrderedList = styled.ol`
  counter-reset: number-counter;
  padding: 0;
  li {
    counter-increment: number-counter;
    display: flex;
    align-items: flex-start;
    ::before {
      content: counter(number-counter) '. ';
      flex-shrink: 0;
      margin-right: 8px;
      width: 20px;
    }
  }
`

const UnorderedList = styled.ul`
  li {
    position: relative;
    padding-left: 28px;
    ::before {
      content: '';
      width: 3px;
      height: 3px;
      flex-shrink: 0;
      border-radius: 100%;
      margin-right: 8px;
      position: absolute;
      left: 9px;
      top: 9px;
      background-color: ${(p) => p.theme.textColor};
    }
  }
`

const IconList = styled.ul`
  li {
    position: relative;
    padding-left: 28px;
    ::before {
      content: '';
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      margin-right: 8px;
      position: absolute;
      left: 0px;
      top: 4px;
      background-image: url('/images/bullet-icon.svg');
    }
  }
`

const Lists = () => {
  return (
    <>
      <Heading>Lists</Heading>
      <Subheading>Numbered list</Subheading>
      <OrderedList>
        <li>Numbered list</li>
        <li>Numbered list</li>
        <li>Numbered list</li>
        <li>Numbered list</li>
      </OrderedList>
      <Subheading>Bulleted list</Subheading>
      <UnorderedList>
        <li>Bulleted list</li>
        <li>Bulleted list</li>
        <li>Bulleted list</li>
        <li>Bulleted list</li>
      </UnorderedList>
      <Subheading>Icon list</Subheading>
      <IconList>
        <li>Icon list</li>
        <li>Icon list</li>
        <li>Icon list</li>
        <li>Icon list</li>
      </IconList>
    </>
  )
}

export default Lists
